import React from 'react'
import Helmet from 'react-helmet'

export default (props) => {
  let { faviconUrl } = props
  const { name } = props
  if (!faviconUrl) {
    faviconUrl = 'hollo_icon.png'
  }
  return (
    <Helmet>
      <title>{`${name} - Jobs` || 'Hollo'}</title>
      <meta name={`${name} - Jobs`} content={`${name} - Jobs`} />
      <link rel="icon" type="image/png" href={faviconUrl} sizes="16x16" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
  )
}
